import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 14.4c1.697 0 3.325-.674 4.525-1.874 1.2-1.2 1.875-2.829 1.875-4.526 0-1.697-.674-3.325-1.875-4.525C11.325 2.275 9.697 1.6 8 1.6c-1.697 0-3.325.674-4.526 1.875C2.274 4.675 1.6 6.303 1.6 8c0 1.697.674 3.325 1.874 4.526C4.674 13.726 6.303 14.4 8 14.4zM6.966 5.834c-.151-.145-.353-.226-.563-.224-.21.002-.41.086-.559.234-.148.149-.232.35-.234.559-.002.21.079.412.224.563L6.87 8 5.834 9.034c-.076.074-.137.163-.179.26-.042.098-.064.203-.065.309 0 .106.02.212.06.31.04.098.1.188.174.263.076.075.165.134.263.174.099.04.204.06.31.06.106-.001.211-.023.309-.065.097-.042.186-.103.26-.18L8 9.132l1.034 1.035c.151.145.353.226.563.224.21-.002.41-.086.559-.234.148-.148.232-.349.234-.559.002-.21-.079-.412-.224-.563L9.13 8l1.035-1.034c.145-.151.226-.353.224-.563-.002-.21-.086-.41-.234-.559-.149-.148-.35-.232-.559-.234-.21-.002-.412.079-.563.224L8 6.87 6.966 5.835z",
  "clip-rule": "evenodd"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}